// Sustainability page Indonesian translations

export default {
  pageTitle: "Keberlanjutan",
  breadcrumbHome: "Beranda",
  breadcrumbSustainability: "Keberlanjutan",
  title: "Keberlanjutan",
  conceptsTitle: "Konsep Keberlanjutan Kami",
  conceptsSubtitle: "Menciptakan masa depan yang berkelanjutan melalui inovasi dan tanggung jawab",
  visionTitle: "Visi Keberlanjutan Eagle Industry",
  visionDesc1: "Di Eagle Industry Indonesia, kami percaya bahwa perusahaan tidak hanya milik pemegang saham tetapi juga karyawan dan masyarakat. Filosofi ini telah lama meresap ke setiap aspek manajemen Grup EKK sejak pendirian kami pada tahun 1990.",
  visionDesc2: "Sebagai bagian dari Eagle Industry Co., Ltd., pemimpin global dalam solusi sealing, kami berkontribusi pada perlindungan lingkungan melalui bisnis inti kami. Mechanical seal kami mencegah gas, minyak, dan fluida lainnya bocor dari mesin, secara langsung membantu melestarikan lingkungan dan mencegah polusi.",
  corePrinciples: "Prinsip Inti Kami:",
  principle1: "Perlindungan lingkungan melalui teknologi pencegahan kebocoran",
  principle2: "Membangun kepercayaan melalui dialog dengan semua pemangku kepentingan",
  principle3: "Menciptakan keuntungan yang adil yang mendukung pertumbuhan abadi",
  principle4: "Mengembangkan produk yang mengatasi masalah regulasi lingkungan",
  learnMoreConcept: "Pelajari Lebih Lanjut Tentang Konsep Keberlanjutan Kami",
  
  esgTitle: "Inisiatif ESG",
  esgSubtitle: "Memperkuat kerangka Lingkungan, Sosial, dan Tata Kelola kami",
  environmentalTitle: "Inisiatif Lingkungan",
  environmentalDesc: "Kegiatat pelestarian lingkungan yang komprehensif sesuai dengan kebijakan lingkungan dan sertifikasi ISO 14001 kami.",
  environmentalFeature1: "Manajemen sumber daya air",
  environmentalFeature2: "Mitigasi pemanasan global",
  environmentalFeature3: "Pengurangan limbah industri",
  
  
  healthTitle: "Kesehatan & Keselamatan Kerja",
  healthDesc: "Sistem manajemen K3 yang komprehensif memastikan keselamatan tempat kerja dan kesejahteraan karyawan.",
  healthFeature1: "Sistem manajemen keselamatan",
  healthFeature2: "Program promosi kesehatan",
  healthFeature3: "Pelatihan dan pendidikan keselamatan",
  
  socialTitle: "Inisiatif Kontribusi Sosial",
  socialDesc: "Mengimplementasikan program sosial yang komprehensif yang mendukung pembangunan masyarakat, pendidikan, dan pengelolaan lingkungan.",
  socialFeature1: "Kampanye kesadaran keberlanjutan",
  socialFeature2: "Transparansi kinerja ESG",
  socialFeature3: "Keterlibatan masyarakat",
  
  learnMore: "Pelajari Lebih Lanjut",
  
  ctaTitle: "Bergabunglah dalam Perjalanan Keberlanjutan Kami",
  ctaDesc: "Kami berkomitmen untuk menciptakan nilai berkelanjutan bagi semua pemangku kepentingan kami. Bersama-sama, kita dapat membangun masa depan yang lebih berkelanjutan melalui inovasi, tanggung jawab, dan kolaborasi.",
  contactUs: "Hubungi Kami"
};